import { defineMessages } from 'react-intl'

const scope = `procurify.core.components.FeaturePromotionModal`

export default defineMessages({
  learnMoreButtonText: {
    id: `${scope}.learnMoreButtonText`,
    defaultMessage: 'Learn more',
  },
})
